import axiosV1 from '@/plugins/axios/configV1';
import axiosNotify from '@/plugins/axios/configNotify';

export default {
  getNotificationCount() {
    return axiosV1.get('dot/notifications');
  },
  getCheckProcessing() {
    return axiosNotify.get('check/import/processing');
  },
  getNotificationCompletion() {
    return axiosNotify.get('notify/approve-all/completion');
  },
	getBellNotifications(params = {}) {
		return axiosV1.get("notifications/bell", { params });
	},
	getViewAllNotifications(params = {}) {
		return axiosV1.get("notifications", { params });
	},
};
